const Data = [
    {
        name: "Sampurna Mandal",
        position: "Public Relations and Marketing Head",
        imageUrl: "/assets/images/members/SampurnaMandal.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Nikhil Lahane",
        position: "Social Strategy Development Head",
        imageUrl: "/assets/images/members/NikhilLahane.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
   
   
]

export default Data;